import { type FC, type ReactNode } from "react";
import { InformationText } from "@root/shared/components/InformationText";
import * as styles from "./styles.css";

type Props = {
  text: string;
  className?: string;
  startIcon?: ReactNode;
};

export const ErrorInformationText: FC<Props> = ({ text, className, startIcon }) => (
  <div className={styles.container}>
    {startIcon && <span className={styles.icon}>{startIcon}</span>}
    <InformationText
      text={text}
      isAlert
      className={`${startIcon ? styles.inlineText : ""} ${className}`}
    />
  </div>
);
